import $ from 'jquery';
import { countCharacters, countWords } from '@/domain/utils/Counter';

const initGlobalListeners = () => {
	// This is our table sorting functionality
	$('#content').on('click', 'a.sortable', function () {
		var sorter = $(this);

		if (sorter.hasClass('sort-asc')) {
			sorter.addClass('sort-desc');
			sorter.removeClass('sort-asc');
		} else {
			sorter.removeClass('sort-desc');
			sorter.addClass('sort-asc');
		}
	});

	$('#content').on('click', 'a.retry-transcoding', function (event) {
		event.preventDefault();
		$.post($(this).attr('href'));
		$(this).replaceWith('<span>Retrying...</span>');
	});

	// Update the indicator
	var updateCountIndicator = function (count, input, selector, data) {
		var indicator = input.closest('.form-group').find(selector + ' .used');
		indicator.text(count);
		indicator.parent().toggleClass('error', count > input.data(data));
	};

	// Bind update function to keyup events
	$('#content').on('keyup change', '[data-max-words]', function () {
		var count = countWords($(this).val());
		updateCountIndicator(count, $(this), '.word-count', 'max-words');
	});

	$('#content').on('keyup change', '[data-max-characters]', function () {
		var count = countCharacters($(this).val());
		updateCountIndicator(count, $(this), '.character-count', 'max-characters');
	});

	// Refresh counters on page load
	$(document).on('pjax:end', function () {
		$('[data-max-words]').each(function () {
			var count = countWords($(this).val());
			updateCountIndicator(count, $(this), '.word-count', 'max-words');
		});

		$('[data-max-characters]').each(function () {
			var count = countCharacters($(this).val());
			updateCountIndicator(count, $(this), '.character-count', 'max-characters');
		});
	});

	// Prevent typing in fields with the .no-type class
	// Especially handy for date, datetime and time fields
	$('input.no-type').keydown(function (e) {
		e.preventDefault();
		return false;
	});

	// Remove target attribute and add ignore class to internal links in the homepage
	$('#home-container a')
		.filter(function () {
			return this.hostname === window.location.hostname;
		})
		.removeAttr('target')
		.addClass('ignore');

	// Prepend default protocol to URL type fields
	$(document).on('focusout', 'input[data-filter="url"]', function () {
		var value = $(this).val();

		if (value && !value.match('^https?://')) {
			$(this).val('https://' + value);
		}
	});

	// Lock button on form submit
	var lockButton = function (i, button) {
		button = $(button);

		button.closest('form').on('submit', function () {
			button.attr('disabled', true);
		});
	};

	$('.lock-on-submit').each(lockButton);

	$(document).on('pjax:end', function () {
		$('.lock-on-submit').each(lockButton);
	});

	// close profile menu when tabbing away
	$('#menu-user > li:last-child > a').keydown(function (e) {
		if (e.which === 9 && e.shiftKey) {
			// do nothing
		} else if (e.which === 9) {
			$('#menu-user').hide();
		}
	});
};

export default initGlobalListeners;
